<template>
    <transition name="toast">
        <div v-if="show" class="toast-notification" :class="`toast-${type}`">
            <span class="toast-icon">{{ icon }}</span>
            <span class="toast-message">{{ message }}</span>
        </div>
    </transition>
</template>

<script>
import { computed } from 'vue';

export default {
    name: 'ToastNotification',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'success',
            validator: (value) => ['success', 'error', 'info'].includes(value)
        }
    },
    setup(props) {
        const icon = computed(() => {
            switch (props.type) {
                case 'success':
                    return '✓';
                case 'error':
                    return '✕';
                case 'info':
                default:
                    return 'ℹ';
            }
        });

        return {
            icon
        };
    }
};
</script>

<style scoped>
.toast-notification {
    position: fixed;
    bottom: 30px;
    right: 30px;
    padding: 16px 24px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
    z-index: 1000;
    font-weight: 500;
}

.toast-success {
    background: rgba(68, 255, 68, 0.2);
    border: 1px solid #44ff44;
    color: #44ff44;
}

.toast-error {
    background: rgba(255, 68, 68, 0.2);
    border: 1px solid #ff4444;
    color: #ff4444;
}

.toast-info {
    background: var(--bg-secondary);
    border: 1px solid var(--accent);
    color: var(--accent);
}

.toast-icon {
    font-size: 20px;
}

.toast-message {
    font-size: 14px;
}

.toast-enter-active,
.toast-leave-active {
    transition: all 0.3s ease;
}

.toast-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.toast-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

@media (max-width: 768px) {
    .toast-notification {
        bottom: 90px;
        right: 20px;
        left: 20px;
    }
}
</style>
